import { exerciseLabel } from '@/lib/exercises';

interface Props {
  reps: number;
  duration: number;
  exercise: string;
}

function StatCard({
  label,
  value,
  sub,
  highlight = false,
}: {
  label: string;
  value: string | number;
  sub?: string;
  highlight?: boolean;
}) {
  return (
    <div className="mx-card px-3 py-3.5">
      <p className="mx-label mb-2">{label}</p>
      <p className={`text-2xl font-semibold tabular-nums leading-none tracking-tight ${
        highlight ? 'text-[var(--mx-accent)]' : 'text-[var(--mx-text)]'
      }`}>
        {value}
      </p>
      {sub && <p className="text-[10px] text-[var(--mx-text-muted)] mt-1.5 truncate">{sub}</p>}
    </div>
  );
}

export function StatsBar({ reps, duration, exercise }: Props) {
  const mins = String(Math.floor(duration / 60)).padStart(2, '0');
  const secs = String(duration % 60).padStart(2, '0');
  const exerciseLabelText = exerciseLabel(exercise);

  return (
    <div className="grid grid-cols-3 gap-2">
      <StatCard label="组次" value={reps} highlight />
      <StatCard label="时长" value={`${mins}:${secs}`} />
      <StatCard label="动作" value={exerciseLabelText} sub={exercise === 'none' ? '等待识别' : undefined} />
    </div>
  );
}
